<template>
  <div class="hm-home">
    <div class="hm-headline">
      <span class="headline">会员营销</span>
      <span class="subhead">导购营销审核</span>
    </div>
    <el-card>
      <div class="panel flex item-center flex-between">
        <div class="button-wrapper">
          <el-button
            size="small"
            type="primary"
            icon="hmicon icon-jiahao"
            @click="tomarketingReason"
            >营销原因管理</el-button
          >
        </div>
        <div class="form-wrapper flex">
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="输入会员卡号"
            v-model.trim="cardNo"
            style="width: 150px"
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <div class="flex table-panel">
          <span
            class="btn"
            :class="{ active: activeTab === v.index }"
            @click="switchTab(v.index)"
            v-for="(v, i) in btnList"
            :key="i"
            >{{ v.name }}</span
          >
        </div>
        <div>
          <el-table border :data="marketingList" style="width: 100%">
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="card_no"
              label="会员卡号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="会员名称"
            >
              <template slot-scope="scope">
                <el-button
                  title="查看用户画像"
                  size="small"
                  type="text"
                  @click="queryOfflineId(scope.row)"
                  >{{ scope.row.user_name }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="mobile_phone"
              label="手机号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="guider_id"
              label="促销员ID"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="门店名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="workName"
              label="导购名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="workNum"
              label="导购工号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="create_time"
              label="提交日期"
              width="200"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="stateFormat"
              label="状态"
              width="200"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="check_time"
              label="审核日期"
              width="200"
            >
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="audit(scope.row)"
                  :disabled="
                    scope.row.stateFormat === '已审核' ||
                      scope.row.stateFormat === '已驳回'
                  "
                  >审核</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="audit(scope.row, 'disabled')"
                  v-show="
                    scope.row.stateFormat === '已审核' ||
                      scope.row.stateFormat === '已驳回'
                  "
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-right">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="marketingListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog title="审核发券" :visible.sync="dialogVisible" width="80%">
      <div class="info">
        <div class="info-item">
          <span>营销会员：</span>
          <span>{{ userInfo.card_no }}（{{ userInfo.user_name }}）</span>
        </div>
        <div class="info-item">
          <span>营销原因：</span>
          <span>{{ userInfo.reason }}</span>
        </div>
        <div class="info-item">
          <span>补充说明：</span>
          <span>{{ userInfo.remark }}</span>
        </div>
        <div class="info-item">
          <span>审核状态：</span>
          <span>
            <el-radio-group v-model="userInfo.state" :disabled="isDisabled">
              <el-radio label="0">
                已审核
              </el-radio>
              <el-radio label="1">
                已驳回
              </el-radio>
            </el-radio-group>
          </span>
        </div>
      </div>
      <div class="transfer-panel flex" v-show="userInfo.state === '0'">
        <el-select
          size="small"
          clearable
          placeholder="选择券类型"
          v-model="couponType"
          class="mr10"
          :disabled="isDisabled"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd"
          v-model="ruleValidDate"
          placeholder="选择时间"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :disabled="isDisabled"
        ></el-date-picker>
        <el-input
          class="mr10"
          size="small"
          clearable
          placeholder="输入券名"
          v-model.trim="couponName"
          :disabled="isDisabled"
        ></el-input>
        <el-button
          size="small"
          @click="resetRules"
          class="mr10 hmicon icon-zhongzhi"
          :disabled="isDisabled"
        >
        </el-button>
        <el-button
          size="small"
          type="primary"
          class="hmicon icon-search"
          style="margin-left: 0"
          @click="queryRules"
          :disabled="isDisabled"
        ></el-button>
      </div>
      <hm-transfer
        :notValid="isDisabled"
        :isPreview="isDisabled"
        v-show="userInfo.state === '0'"
        ref="ruleTransfer"
        background="danger"
        leftName="可选规则"
        rightName="已选择的规则"
        :leftOption="leftRules"
        transferMode="selectRule"
      ></hm-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submit(userInfo)"
          size="small"
          :disabled="isDisabled"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <hm-user-profile
      ref="userProfile"
      :offlineVipId="offlineVipId"
      :currentRow="currentRow"
      @resetOfflineId="resetOfflineId"
    ></hm-user-profile>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HmTransfer from "../../components/HmTransfer";
import HmUserProfile from "../../components/HmUserProfile";
export default {
  data() {
    return {
      dialogVisible: false,
      offlineVipId: "",
      currentRow: null,
      activeTab: "2",
      currentPage: 1,
      cardNo: "",
      couponType: "",
      isDisabled: false,
      ruleValidDate: "",
      couponName: "",
      userInfo: "",
      leftRules: [],
      data: [{}],
      btnList: [
        { name: "未审核", active: false, index: "2" },
        { name: "已审核", active: false, index: "0" },
        { name: "已驳回", active: false, index: "1" },
        { name: "全部", active: false, index: "" }
      ],
      options: [
        { name: "满减券类", active: true, value: 0 },
        { name: "兑换券类", active: false, value: 1 },
        { name: "运费券类", active: false, value: 2 },
        { name: "折扣券类", active: false, value: 3 },
        { name: "服务券类", active: false, value: 4 },
        { name: "满量券类", active: false, value: 5 }
      ]
    };
  },
  components: {
    HmTransfer,
    HmUserProfile
  },
  computed: mapState({
    allRules: state => state.rules.allRules,
    marketingList: state => state.marketing.marketingList,
    marketingListTotal: state => state.marketing.marketingListTotal,
    auditMarketingReasonCode: state => state.marketing.auditMarketingReasonCode,
    auditedMaketingReason: state => state.marketing.auditedMaketingReason
  }),
  mounted() {
    this.$store.dispatch("queryMarketingList", {
      state: this.activeTab,
      pageSize: 10,
      pageNo: this.currentPage
    });
  },
  watch: {
    dialogVisible() {
      if (this.$refs.ruleTransfer) {
        this.$refs.ruleTransfer.rightData = [];
        this.$refs.ruleTransfer.rightChecked = [];
        this.$refs.ruleTransfer.rightCheckAll = false;
        this.$refs.ruleTransfer.leftData = [];
        this.$refs.ruleTransfer.leftChecked = [];
        this.$refs.ruleTransfer.leftCheckAll = false;
      }
    },
    auditedMaketingReason(val) {
      if (val.length) {
        val.forEach(v => {
          if (v.type === 0) {
            v.type = "满减券";
          } else if (v.type === 1) {
            v.type = "折扣券";
          } else if (v.type === 2) {
            v.type = "运费券";
          }
        });
        this.$refs.ruleTransfer.rightData = val;
      }
    },
    auditMarketingReasonCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功,",
          type: "success"
        });
        this.$store.dispatch("queryMarketingList", {
          state: this.activeTab,
          pageSize: 10,
          pageNo: this.currentPage
        });
      }
      this.dialogVisible = false;
      this.$store.commit("auditMarketingReason", "");
    },
    allRules(val) {
      if (val && val.length > 0) {
        val.forEach(v => {
          if (v.type === 0) {
            v.type = "满减券";
          } else if (v.type === 1) {
            v.type = "兑换券";
          } else if (v.type === 2) {
            v.type = "运费券";
          } else if (v.type === 3) {
            v.type = "折扣券";
          } else if (v.type === 4) {
            v.type = "服务券";
          } else if (v.type === 5) {
            v.type = "满量券";
          }
        });
      }
      this.leftRules = val;
    }
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.$store.dispatch("queryMarketingList", {
        pageSize: 10,
        pageNo: this.currentPage,
        cardNo: this.cardNo,
        state: this.activeTab
      });
    },
    submit(userInfo) {
      const transfer = this.$refs.ruleTransfer;
      if (userInfo.state === "0" && transfer.rightChecked.length > 0) {
        const rule = [];
        transfer.rightChecked.forEach(v => {
          if (v.type === "满减券") {
            v.type = 0;
          } else if (v.type === "兑换券") {
            v.type = 1;
          } else if (v.type === "运费券") {
            v.type = 2;
          } else if (v.type === "折扣券") {
            v.type = 3;
          } else if (v.type === "服务券") {
            v.type = 4;
          } else if (v.type === "满量券") {
            v.type = 5;
          }
          rule.push({
            ruleId: v.ruleId,
            num: v.num,
            ruleName: v.name,
            type: v.type
          });
        });
        this.$store.dispatch("auditMarketingReason", {
          state: userInfo.state,
          checkId: userInfo.id,
          sendName: userInfo.reason,
          memberMobile: userInfo.mobile_phone,
          guiderId: userInfo.guider_id,
          rule
        });
      } else if (userInfo.state === "1") {
        this.$store.dispatch("auditMarketingReason", {
          state: userInfo.state,
          checkId: userInfo.id
        });
      }
    },
    audit(userInfo, isDisabled) {
      this.$store.dispatch("queryAuditedMaketingReason", {
        checkId: userInfo.id
      });
      this.isDisabled = isDisabled;
      this.userInfo = userInfo;
      this.dialogVisible = true;
    },
    switchTab(index) {
      this.activeTab = index;
      this.currentPage = 1;
      this.$store.dispatch("queryMarketingList", {
        pageSize: 10,
        pageNo: this.currentPage,
        cardNo: this.cardNo,
        state: this.activeTab
      });
    },
    paging(page) {
      this.currentPage = page;
      this.$store.dispatch("queryMarketingList", {
        pageSize: 10,
        pageNo: this.currentPage,
        cardNo: this.cardNo,
        state: this.activeTab
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.$store.dispatch("queryMarketingList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        cardNo: this.cardNo,
        state: this.activeTab
      });
    },
    tomarketingReason() {
      this.$router.push({ name: "marketingReason" });
    },
    resetRules() {
      this.couponType = "";
      this.ruleValidDate = [];
      this.couponName = "";
    },
    queryRules() {
      const startDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[0]
          : "";
      const endDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[1]
          : "";
      this.$store.dispatch("getAllRules", {
        isSend: 1,
        name: this.couponName,
        startDate,
        endDate,
        pageNo: this.currentPage,
        pageSize: 10000,
        status: 1,
        type: this.couponType
      });
    },
    queryOfflineId(row) {
      this.offlineVipId = row.card_no;
      this.currentRow = row;
    },
    resetOfflineId() {
      this.offlineVipId = "";
    }
  }
};
</script>

<style scoped lang="scss">
.table {
  padding-top: 10px;
}

.info {
  padding-bottom: 10px;
  .info-item {
    line-height: 2rem;
  }
}

.link {
  color: #409eff;
  font-size: 12px;
}
</style>
